import { TableHeadersType } from "../../constant/tableHeadersConstants/tableHeadersType";
import { MasterActivityCodeListingTypes } from "../../redux/masterData/masterTypes";
import { tableEditIcon } from "../../assets/images";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import UpdatedByAndUpdatedAt from "../commons/CommonUpdatedByAndUpdatedAt";
import { formateDateTime } from "../../utils/commonFunctions";

type AppProps = {
  tableHeaders: TableHeadersType[] | [];
  data: MasterActivityCodeListingTypes [] | [];
  handleEditMasterActivityCode:(data:MasterActivityCodeListingTypes)=>void
  isUpdateActivityCodePresent?:boolean;
};

const ActivityCodeTable = ({ tableHeaders, data ,handleEditMasterActivityCode,isUpdateActivityCodePresent}: AppProps) => {
  return (
    
    <>
      {data?.length > 0 &&
        data?.map((activityCodeData: MasterActivityCodeListingTypes) => {
          return (
            <tr className="text-left">
              {tableHeaders?.length > 0 &&
                tableHeaders?.map((header: TableHeadersType) => {
                  if (header?.value == "activity_code") {
                    return (
                      <td className="text-left" style={{whiteSpace:'nowrap'}}>
                        {activityCodeData?.activity_code?.length>25 ? (
                          <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 250 }}
                          overlay={
                            <Tooltip id="button-view">
                              {activityCodeData?.activity_code}
                            </Tooltip>
                          }
                        >
                          <span>
                            {activityCodeData?.activity_code.toLowerCase()?.substr(0, 20) +
                              (activityCodeData?.activity_code && activityCodeData?.activity_code?.length > 20
                                ? "..."
                                : "")}
                          </span>
                        </OverlayTrigger>
                        ): (activityCodeData?.activity_code)}
                        </td> 

                    )
                  } else if (header?.value == "description") {
                    return (
                      <td className="text-left" style={{minWidth:'200px'}}>
                        {activityCodeData?.description}
                      </td>
                    );
                  } 
                  else if (header?.value == "activity_code_type") {
                    return (
                      <td className="text-left" >
                        {activityCodeData?.activity_code_type}
                      </td>
                    );
                  } 
                  else if (header?.value === "updated_by") {
                    return (
                      <td style={{width:'180px'}}>
                         <UpdatedByAndUpdatedAt
                          firstName={activityCodeData?.updated_by?.first_name?activityCodeData?.updated_by?.first_name:""}
                          lastName={activityCodeData?.updated_by?.last_name}
                          profilePic={activityCodeData?.updated_by?.profile_pic?.file_url}
                          updatedAt={activityCodeData?.updated_at?formateDateTime(activityCodeData?.updated_at):""}
              />
                        
                      </td>
                    );
                  }
                  
                  else if (header?.value == "edit") {
                    return (
                      <td style={{ textAlign: "start" }}>
                        {isUpdateActivityCodePresent && 
                        <span className="d-inline-block pointer" onClick={()=>handleEditMasterActivityCode(activityCodeData)}> 
                          <div
                            style={{
                              color: "#d43",
                              fontSize: 20,
                              cursor:"pointer"
                            }}
                          >
                            <img src={tableEditIcon}alt ="edit"/>

                          </div>
                        </span>
                        }
                      </td>
                    );
                  }
                  return null;
                })}
            </tr>
          );
        })}
    </>
  );
};

export default ActivityCodeTable;

